// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.t-center[data-v-a9bef7de] {text-align:center; vertical-align:text-top;}\n.t-left[data-v-a9bef7de]   {text-align:left; vertical-align:text-top; color: red;}\n", ""]);
// Exports
module.exports = exports;
